module.exports = __webpack_public_path__ + "static/service-boundary-4-7d1b9cd4303240967702b950d417f099.png";